import {Skeleton} from "primereact/skeleton"
import {useEffect} from "react"
import useSWR from "swr"

import SubHeader from "../components/SubHeader"
import {fetcherGet} from "../utilities/general"
import {PreceptorOrientationSummary} from "../components/preceptor/PreceptorOrientationSummary"

const PreceptorOrientations = () => {
    useEffect(() => {
        document.title = "My Orientees"
    }, [])
    const {data: orientees, isLoading} = useSWR("/preceptorships?status=Active&status=Paused", fetcherGet, {
        fallbackData: [],
    })

    return (
        <>
            <SubHeader title1="" title2="My Orientees" icon="fa-user-nurse">
                <div className="d-flex flex-row flex-grow-1 justify-content-end align-items-center gap-3">
                    <a
                        href={`/surveys/orientation-status-report-selection?guestPreceptor=true`}
                        className="btn btn-light-primary d-flex align-items-sm-center  px-3"
                    >
                        Complete OSR as Guest Preceptor
                    </a>
                </div>
            </SubHeader>
            <div className="container d-flex flex-column">
                {isLoading ? (
                    <div className="card p-8 mt-6">
                        <Skeleton width="100%" height="10rem" />
                    </div>
                ) : !orientees || orientees.length === 0 ? (
                    <div className="card mt-4">
                        <div className="card-body">
                            <p className="card-text">No assigned orientations.</p>
                        </div>
                    </div>
                ) : (
                    orientees.map((orientation) => (
                        <PreceptorOrientationSummary orientation={orientation} key={orientation.id} />
                    ))
                )}
            </div>
        </>
    )
}

export default PreceptorOrientations
